import { render, staticRenderFns } from "./Corredurias.vue?vue&type=template&id=4c98a344"
import script from "./Corredurias.vue?vue&type=script&lang=js"
export * from "./Corredurias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c98a344')) {
      api.createRecord('4c98a344', component.options)
    } else {
      api.reload('4c98a344', component.options)
    }
    module.hot.accept("./Corredurias.vue?vue&type=template&id=4c98a344", function () {
      api.rerender('4c98a344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/corredurias/Corredurias.vue"
export default component.exports